import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { initPaddle }   from './paddle';

const pixelId = process.env.REACT_APP_PIXEL_ID;
const tiktokPixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;
const twitterPixelId = process.env.REACT_APP_TWITTER_PIXEL_ID;

const useFacebookPixel = process.env.REACT_APP_USE_FACEBOOK_PIXEL === 'true';
const useTikTokPixel = process.env.REACT_APP_USE_TIKTOK_PIXEL === 'true';
const useTwitterPixel = process.env.REACT_APP_USE_TWITTER_PIXEL === 'true';


document.addEventListener(
  'gesturestart',
  (e) => e.preventDefault(),
  { passive: false }
);

document.addEventListener(
  'gesturechange',
  (e) => e.preventDefault(),
  { passive: false }
);

let lastTouchEnd = 0;
document.addEventListener(
  'touchend',
  (e) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  },
  false
);

const updateAppHeight = () => {
  const rootElement = document.getElementById('root');
  rootElement.style.height = `${window.innerHeight}px`;
};

updateAppHeight();

window.addEventListener('resize', updateAppHeight);

if (useFacebookPixel && pixelId) {
(function(f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function() {
    n.callMethod ?
      n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = true;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

window.fbq('init', pixelId, {}, { autoConfig: false, allowAutoMatch: false });
window.fbq('track', 'PageView');

const insertMetaNoscript = () => {
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`;
  noscript.appendChild(img);
  document.body.appendChild(noscript);
};
window.addEventListener('load', insertMetaNoscript);
}

if (useTikTokPixel && tiktokPixelId) {
(function (w, d, t) {
  w.TiktokAnalyticsObject = t;
  var ttq = w[t] = w[t] || [];
  ttq.methods = [
    "page", "track", "identify", "instances", "debug", "on", "off",
    "once", "ready", "alias", "group", "enableCookie", "disableCookie",
    "holdConsent", "revokeConsent", "grantConsent"
  ];

  ttq.setAndDefer = function(t, e) {
    t[e] = function() {
      t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
    };
  };

  for (var i = 0; i < ttq.methods.length; i++) {
    ttq.setAndDefer(ttq, ttq.methods[i]);
  }

  ttq.instance = function(t) {
    var instance = ttq._i[t] || [];
    for (var n = 0; n < ttq.methods.length; n++) {
      ttq.setAndDefer(instance, ttq.methods[n]);
    }
    return instance;
  };

  ttq.load = function(e, n) {
    var r = "https://analytics.tiktok.com/i18n/pixel/events.js";
    ttq._i = ttq._i || {};
    ttq._i[e] = [];
    ttq._i[e]._u = r;
    ttq._t = ttq._t || {};
    ttq._t[e] = +new Date();
    ttq._o = ttq._o || {};
    ttq._o[e] = n || {};

    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = r + "?sdkid=" + e + "&lib=" + t;
    var firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  };

  ttq.load(tiktokPixelId);
  ttq.page();
})(window, document, 'ttq');

const insertTikTokNoscript = () => {
  const noscript = document.createElement('noscript');
  const img = document.createElement('img');
  img.height = 1;
  img.width = 1;
  img.style.display = 'none';
  img.src = `https://analytics.tiktok.com/i18n/pixel/events.js?id=${tiktokPixelId}&noscript=1`;
  noscript.appendChild(img);
  document.body.appendChild(noscript);
};
window.addEventListener('load', insertTikTokNoscript);
}

if (useTwitterPixel && twitterPixelId) {
(function(e, t, n, s, u, a) {
  if (e.twq) return;
  s = e.twq = function() {
    s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
  };
  s.version = '1.1';
  s.queue = [];
  u = t.createElement(n);
  u.async = true;
  u.src = 'https://static.ads-twitter.com/uwt.js';
  a = t.getElementsByTagName(n)[0];
  a.parentNode.insertBefore(u, a);
})(window, document, 'script');

window.twq('config', twitterPixelId);
}

(async () => {
  try {
    await initPaddle();
  } catch (e) {
    console.error('Paddle init failed:', e);
  }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   <BrowserRouter>
    <App />
   </BrowserRouter>
  </React.StrictMode>
  );
})();

reportWebVitals();


